import { LogoutOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import { Link } from "@tanstack/react-router";
import { Dropdown } from "antd";
import { ItemType } from "antd/es/menu/interface";
import {usePaldockTranslation} from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser.ts";

export const AccountDropdown = () => {
    const { t: tG } = usePaldockTranslation("general");
    const { t: tC } = usePaldockTranslation("common");
    const userUtils = useUser();

    const handleLogout = () => {
        userUtils.logoutUser();
    };

    const menuItems: ItemType[] = [
        {
            key: "nickname",
            label: <span className="cursor-default">{userUtils.getAuthenticatedUser()?.nickname}</span>,
            disabled: true,
        },
        {
            key: "divider1",
            type: "divider",
        },
        {
            key: "account",
            icon: <SettingOutlined />,
            label: <Link to="/account">{tG("account-dropdown.account_settings")}</Link>,
        },
        {
            key: "divider2",
            type: "divider",
        },
        {
            key: "logout",
            icon: <LogoutOutlined />,
            label: tC("logout"),
            onClick: handleLogout,
        },
    ];

    return (
        <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
            <UserOutlined />
        </Dropdown>
    );
};
